import React, { useState } from "react";
import CollapsibleSection from "./CollapsibleSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CustomerTestimonialsPanel = ({
    isOpen,
    onToggle,
    testimonials,
    updateTestimonial,
    removeTestimonial,
    addTestimonial
}) => {
    const [hoveredStars, setHoveredStars] = useState({});
    const [flashingStars, setFlashingStars] = useState({});

    return (
        <CollapsibleSection
            title="💬 Customer Testimonials"
            isOpen={isOpen}
            onToggle={onToggle}
        >
            <div className="form-section">
                <small className="note testimonialsNote">
                    Share what your customers are saying. Max 3 shown on your public profile.
                </small>

                {testimonials.map((t, idx) => (
                    <div key={idx} className="testimonial-edit">
                        <div className="space-div"></div>

                        <textarea
                            placeholder="What did the customer say?"
                            value={t.blurb}
                            onChange={(e) => updateTestimonial(idx, "blurb", e.target.value)}
                        />

                        <input
                            type="text"
                            placeholder="Customer name"
                            value={t.name}
                            onChange={(e) => updateTestimonial(idx, "name", e.target.value)}
                        />

                        <input
                            type="text"
                            placeholder="City / State"
                            value={t.city}
                            onChange={(e) => updateTestimonial(idx, "city", e.target.value)}
                        />

                        <div className="star-rating">
                            <small className="note stars">Click a star to set the rating</small>
                            {[1, 2, 3, 4, 5].map((r) => {
                                const isFilled = r <= (hoveredStars[idx] ?? t.rating);
                                const isHovered = hoveredStars[idx] === r;
                                const isFlashing = flashingStars[idx] === r;

                                return (
                                    <span
                                        key={r}
                                        className={`star ${isFilled ? "filled" : ""} ${isHovered ? "hovered" : ""} ${isFlashing ? "flash" : ""}`}
                                        onMouseEnter={() =>
                                            setHoveredStars((prev) => ({ ...prev, [idx]: r }))
                                        }
                                        onMouseLeave={() =>
                                            setHoveredStars((prev) => ({ ...prev, [idx]: undefined }))
                                        }
                                        onClick={() => {
                                            updateTestimonial(idx, "rating", r);
                                            setFlashingStars((prev) => ({ ...prev, [idx]: r }));
                                            setTimeout(() => {
                                                setFlashingStars((prev) => {
                                                    const clone = { ...prev };
                                                    delete clone[idx];
                                                    return clone;
                                                });
                                            }, 400); // duration of flash
                                        }}
                                    >
                                        ★
                                    </span>
                                );
                            })}
                        </div>

                        <button
                            type="button"
                            className="btn-delete-testimonial"
                            title="Delete this testimonial"
                            onClick={() => removeTestimonial(idx)}
                        >
                            ✖ Delete
                        </button>
                    </div>
                ))}

                <button
                    className="btn-add-testimonial"
                    type="button"
                    onClick={addTestimonial}
                >
                    <FontAwesomeIcon icon={["fas", "plus"]} />
                    &nbsp;Add Testimonial
                </button>
            </div>
        </CollapsibleSection>
    );
};

export default CustomerTestimonialsPanel;